import React, { useState } from "react";
import "./EATextField.scss";
import EAButton from "../Buttons/EAButton";

interface IProps {
  label?: string;
  name: string;
  type?: "text" | "password" | "email" | "number";
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  error?: boolean;
  success?: boolean;
  fullWidth?: boolean;
  helperText?: string;
  inputButtonTitle?: string;
  onInputButtonClick?: () => void;
  inputButtonDisabled?: boolean;
  register?: any;
  /** Atrybut HTML `maxLength` na polu tekstowym. */
  inputMaxLength?: number;
}

const EATextField: React.FC<IProps> = ({
  label,
  name,
  type = "text",
  value,
  onChange,
  placeholder = "",
  disabled = false,
  error = false,
  success = false,
  fullWidth = false,
  helperText = "",
  inputButtonTitle,
  onInputButtonClick,
  inputButtonDisabled = false,
  register,
  inputMaxLength,
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const inputType = type === "password" && isPasswordVisible ? "text" : type;
  return (
    <div className={`custom-text-field ${fullWidth ? "full-width" : ""}`}>
      {label && (
        <label className={`custom-text-field__label ${disabled ? "disabled" : ""}`} htmlFor={name}>
          {label}
        </label>
      )}
      <div className={`custom-text-field__input-wrapper ${error ? "error" : ""} ${success ? "success" : ""}`}>
        <input
          name={name}
          id={name}
          type={inputType}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          className="custom-text-field__input"
          maxLength={inputMaxLength}
          {...register}
        />
        {type === "password" && (
          <button
            type="button"
            className="custom-text-field__toggle-password"
            onClick={togglePasswordVisibility}
            disabled={disabled}
          >
            {isPasswordVisible ? "🙈" : "👁️"}
          </button>
        )}
        {inputButtonTitle && (
          <div className="custom-text-field__input-button">
            <EAButton
              title={inputButtonTitle}
              onClick={onInputButtonClick}
              disabled={inputButtonDisabled || disabled}
            />
          </div>
        )}
      </div>
      {helperText && (
        <p className={`custom-text-field__helper-text ${error ? "error" : ""} ${success ? "success" : ""}`}>
          {helperText}
        </p>
      )}
    </div>
  );
};

export default EATextField;
